import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDatepickerModule } from '@angular/material/datepicker';

import { TiimeIconModule } from '../icon/index';

@NgModule({
  declarations: [],
  imports: [CommonModule, MatDatepickerModule, TiimeIconModule],
  exports: [MatDatepickerModule]
})
export class TiimeDatepickerModule {}
